import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {WebsiteModuleState} from "./models/website-module.state";
import {WebsiteModuleConfig} from "./website-module.config";

export class WebsiteModuleStore extends BaseMobxStore {
  static injectables = [WebsiteModuleConfig, WebsiteModuleState];
}
